/**
 * Le prix affiché est une promotion : nature catalogue `promo`, ou catégorie Tolède `P`.
 * Sert à décider l'appel hors panier, sans influer sur le tag de prix.
 */
export function prixAfficheEstPromo(
  typePrix?: string,
  categorieDeTarif?: string,
): boolean {
  return typePrix === 'promo' || categorieDeTarif === 'P';
}
